import BaseService from '_services/rest/base';

class RatingService extends BaseService {
  constructor() {
    super();
  }

  checkToken(token) {
    return this.request(`${this.getUrl()}/find/${token}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getUrl() {
    return `${super.getUrl()}api/rating`;
  }

  getRating(id) {
    return this.request(`${this.getUrl()}/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getRatingList() {
    return this.request(`${this.getUrl()}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getAnswers(pagination) {
    return this.request(`${this.getUrl()}/${pagination.id}/answer/all/${pagination.skip}/${pagination.take}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  getUserAnswer(id) {
    return this.request(`${this.getUrl()}/user/${id}`)
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  resend(id) {
    return this.request(`${this.getUrl()}/resend/${id}`)
      .catch(err => {
        throw err;
      });
  }

  updateRating(params) {
    return this.request(`${this.getUrl()}/${params.id}`, params, 'PUT')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveQuestions(id, questions) {
    return this.request(`${this.getUrl()}/${id}/question`, questions, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }

  saveAnswers(answers, token) {
    return this.request(`${this.getUrl()}/${token}/answer`, answers, 'POST')
      .then(this.handleResponse)
      .catch(err => {
        throw err;
      });
  }
}

export default new RatingService();
